import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 — redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/api/auth/login', { email, password });
export const register = (data) => api.post('/api/auth/register', data);
export const getMe = () => api.get('/api/auth/me');

// Publishers (admin)
export const getPublishers = () => api.get('/api/publishers');
export const createPublisher = (data) => api.post('/api/publishers', data);
export const updatePublisher = (id, data) => api.put(`/api/publishers/${id}`, data);
export const getPublisher = (id) => api.get(`/api/publishers/${id}`);
export const regenerateKey = (id) => api.post(`/api/publishers/${id}/regenerate-key`);

// Analysis
export const getAnalysisOverview = (params) => api.get('/api/analysis/overview', { params });
export const getBidderAnalysis = (params) => api.get('/api/analysis/bidders', { params });
export const getAdUnitAnalysis = (params) => api.get('/api/analysis/adunits', { params });
export const getIssues = (params) => api.get('/api/analysis/issues', { params });

// Trends
export const getDailyTrends = (params) => api.get('/api/trends/daily', { params });
export const getBidderTrends = (params) => api.get('/api/trends/bidders', { params });
export const triggerAggregation = (data) => api.post('/api/trends/aggregate', data);

export default api;
